import { useRouter } from "next/router";
import { FunctionComponent, ReactNode, Suspense } from "react";

import { readCskPreviewFromQuery } from "src/utils/csk-preview";
import type { StoryThemeConfig } from "src/utils/story-theme-page-options";

export interface ArticleStorySuspenseProps {
  storyTheme: StoryThemeConfig;
  loadingFallback: ReactNode;
  children: ReactNode;
}

/**
 * Outer article shell: optional `?csk=suspense` (or `?preview=suspense`), and
 * Suspense boundary. Story nav chrome is in `ArticleStoryChrome`.
 *
 * Do not read the URL via useSyncExternalStore here — updating this component
 * during hydrate makes the Suspense boundary fall back to client rendering.
 */
const ArticleStorySuspense: FunctionComponent<ArticleStorySuspenseProps> = ({
  loadingFallback,
  children,
}) => {
  const router = useRouter();
  const isDev = process.env.NODE_ENV === "development";
  const showSuspensePreview =
    isDev &&
    router.isReady &&
    readCskPreviewFromQuery(router.query) === "suspense";

  return showSuspensePreview ? (
    loadingFallback
  ) : (
    <Suspense fallback={loadingFallback}>{children}</Suspense>
  );
};

export default ArticleStorySuspense;
